<template>
  <!-- <pre v-if="kawalanResponse"> testData={{ kawalanResponse }}</pre> -->
  <AdminBackground v-if="piagamResponse && kawalanResponse && kawalanData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/OSC 3.0 PLUS ONLINE.png"
        alt="OSC 3.0 PLUS ONLINE"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppDateTimePicker
            :key="datePickerKey"
            v-model="dateRange"
            label="Tarikh"
            placeholder="Pilih Tarikh"
            :config="{ mode: 'range' }"
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
        <button
          class="filter-btn"
          @click="filterData"
        >
          SARING
        </button>
      </div> 
      <div class="chart-container">
        <div
          v-for="(chart, index) in charts"
          :key="index"
          class="chart-item"
        >
          <h2>{{ chart.title }}</h2>
          <DonutChart
            :chart-data="chart.data"
            :chart-title="chart.title"
          />
          <Update />
        </div>
      </div>
    </div>
    <div class="content-wrapper1">
      <div class="pbtpay-status">
        <h2>TEMPOH PIAGAM PERMOHONAN</h2>
        <VTable
          height="450"
          class="text-no-wrap"
        >
          <thead>
            <tr>
              <th>No</th>
              <th>Nama</th>
              <th>Tempoh Minima</th>
              <th>Tempoh Maxima</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in piagamResponse || []"
              :key="index"
            >
              <td>{{ (index + 1) || 0 }}</td>
              <td>{{ item?.kpi_name || '0' }}</td>
              <td>{{ item?.days || 0 }} Hari</td>
              <td>{{ item?.max_days || 0 }} Hari</td>
            </tr>
          </tbody>
        </VTable>
      </div>
    </div>
  </AdminBackground>
  <PrimaryModule />
  <KawalanPemajuanMenu />
</template>


<script setup>
import KawalanPemajuanMenu from '@/components/menu-items/section-menu/kawalan-pemajuan-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

const JumlahPermohonan=ref([])
const PeratusanPermohonan=ref([])
const StatusPermohonan=ref([])
const PermohonanKM=ref([])
const PermohonanInfra=ref([])
const PelanEndorsan=ref([])
const StatusProjek=ref([])
const BorangB=ref([])
const PendepositanCCC=ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const charts = ref([
  { title: 'Jumlah Permohonan Mengikut Kategori', data: JumlahPermohonan },
  { title: 'Peratusan Permohonan', data: PeratusanPermohonan },
  { title: 'Status Keseluruhan Permohonan', data: StatusPermohonan },
  { title: 'Bilangan Permohonan KM', data: PermohonanKM },
  { title: 'Jumlah Permohonan Infra', data: PermohonanInfra },
  { title: 'Bilangan Pelan Endorsan', data: PelanEndorsan },
  { title: 'Status Projek', data: StatusProjek },
  { title: 'Borang B (Notifikasi mula kerja binaan)', data: BorangB },
  { title: 'Pendepositan CCC', data: PendepositanCCC },
])

const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion } = useHttpService()

const dateRange=ref()
const kawalanResponse = ref(null)
const piagamResponse = ref(null)
const kawalanData = ref()

async function loadDataFromApi() {
  try {
    const res = await fetch('https://jktgateway.kpkt.gov.my/api/kawalan-pemajuan/piagam-permohonan')
    const piagam = await res.json()

    piagamResponse.value = piagam?.data || []
  } catch (err) {
    console.error('loadDataFromApi failed:', err)
    piagamResponse.value = []
  }
}

async function loadDataFromApikawalan(dateFrom, dateTo, state = selectedsState.value, pbtValue = selectedPbt.value){
  try {
    const plainStates = toRaw(state)  
    let queryParams = ''

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // const kawalan = await httpGet(`kawalan-pemajuan?date_from=${dateFrom}&date_to=${dateTo}${queryParams}`)
 
    const res = await fetch(`https://jktgateway.kpkt.gov.my/api/kawalan-pemajuan?date_from=${dateFrom}&date_to=${dateTo}${queryParams}`)
    const kawalan = await res.json()


    states.value = ["Semua Negeri"]
    kawalan.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = kawalan.councils
    kawalanData.value = kawalan
    kawalanResponse.value = kawalan.submission_type
    
    // console.log("API Response: ", kawalanResponse.value) 

    const jumlah = kawalan.submission_type || {}
    const peratusan = kawalan.application_percent || {}
    const status = kawalan.application_status || {}
    const permohonan = kawalan.submission_km || {}
    const infra = kawalan.submission_infra || {}
    const endorsan = kawalan.pelan_endorsan || {}
    const projek = kawalan.project_status || {}
    const borang = kawalan.borang_b || {}
    const pendepositan = kawalan.pendepositan_ccc || {}

    JumlahPermohonan.value = Object.entries(jumlah).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
    PeratusanPermohonan.value = Object.entries(peratusan).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
    StatusPermohonan.value = Object.entries(status).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
    PermohonanKM.value = Object.entries(permohonan).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
    PermohonanInfra.value = Object.entries(infra).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
    PelanEndorsan.value = Object.entries(endorsan).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
    StatusProjek.value = Object.entries(projek).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
    BorangB.value = Object.entries(borang).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
    PendepositanCCC.value = Object.entries(pendepositan).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )
  } catch (err) {
    console.error('loadDataFromApikawalan failed:', err)
  }
}

function handleStateChange() {
  pbt.value = []
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }
  if (selectedsState.value.includes("Semua Negeri")) {
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }
}
function filterData() {
  if (dateRange.value && dateRange.value.length === 24) {
    const dateFrom = dateRange.value.substring(0, 10)
    const dateTo = dateRange.value.substring(14)
 
    loadDataFromApikawalan(dateFrom, dateTo, selectedsState.value, selectedPbt.value)
  }
}

onMounted(() => {
  loadDataFromApi()

  const defaultDateFrom = '2024-01-01T00:00:00.000Z'
  const defaultDateTo = new Date().toISOString()

  loadDataFromApikawalan(defaultDateFrom, defaultDateTo)


})

watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedsState, selectedPbt], () => {
  loadDataFromApikawalan( selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>

<style scoped>
.chart-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
}

.chart-item {
  flex: 1 1 calc(50% - 20px);
  max-width: calc(50% - 20px);
  background: rgba(255, 254, 254, 80%);
  padding: 20px;
  border-radius: 10px;
}


.date-label-container {
  flex-grow: 1;
}

.button-wrapper {
  margin-block-start: 40px;
  margin-inline-start: 10px;
}



.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1200px;
}


.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  background-color: rgba(255, 255, 255, 65%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1500px;
}

.content-wrapper1 {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  background-color: rgba(255, 255, 255, 65%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1500px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

/* Add styles for the new Saring button */
.filter-btn {
  border: none;
  border-radius: 5px;
  background-color: #13017f;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 10%);
  color: white;
  cursor: pointer;
  font-size: 1rem;
  margin-inline-start: 40px; /* Spacing between date picker and button */
  padding-block: 10px;
  padding-inline: 20px;
}

.filter-btn:hover {
  background-color: #001f73; /* Darker shade on hover */
}

h2 {
  display: block;
  color: #150069;
  font-size: 20px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start !important;
  text-transform: uppercase;
}

h3 {
  position: relative;
  display: flex;
  align-items: center;
  color: #000;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  inline-size: 160px;
  margin-block-start: 10px;
  text-align: start;
}

.filter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  inline-size: 100%;
  margin-block-end: 20px;
}

.content {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  inline-size: 100%;
}

/* Image Grid */
.image-grid {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(7, 1fr);
  inline-size: 100%;
  max-inline-size: 1600px;
}

.text-overlay {
  position: absolute;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  inline-size: 100%;
  inset-block-end: 0;
  padding-block: 20px;
  padding-inline: 0;
  text-align: center;
}

.name {
  color: white;
  font-size: 10px;
  font-weight: 600;
  margin-block-end: 25px;
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 110%;
  padding-block-start: 90%;
}

.image-container img {
  position: absolute;
  block-size: 100%;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  object-fit: cover;
}


.number {
  color: #a80000;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
}


.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1900px;
}

th {
  background-color: #fff;
  color: #150069 !important;
  font-size: 1.2rem;
  font-weight: bold;
}

td {
  background-color: #fff;
  color: #333;
  font-size: 1.1rem;
}

/* General table styles */
table {
  border-collapse: collapse;
  inline-size: 100%;
}

th,
td {
  padding: 15px;
  border: 1px solid #ddd;
  text-align: start;
}

@media (max-width: 1024px) {
  .content-wrapper {
    padding: 20px;
    max-width: 1000px; /* Adjusts the maximum width */
    margin: 20px auto;
  }

  .image-grid {
    gap: 25px;
    grid-template-columns: repeat(5, 1fr); /* Reduces columns to 5 for better spacing */
  }

  .text-overlay {
    position: absolute;
    bottom: 19px; /* Positions overlay slightly higher */
    padding: 10px;
    width: 90%; /* Reduces overlay width slightly */
    text-align: center;
    border-radius: 8px;
  }

  .text-overlay .name {
    font-size: 0.9rem;
    font-weight: bold;
    line-height: 1.2;
    margin: 30;
  }

  .text-overlay .number {
    font-size: 1.5rem; /* Adjusts font size for number */
    color: #a80000;
    font-weight: bold;
  }

  /* Adjust the container to give enough space for the text overlay */
  .image-container {
    position: relative;
    padding-block-start: 95%; /* Increases padding slightly */
  }

  .image-container img {
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Enhances box shadow */
  }

  h2 {
    font-size: 1.4rem; /* Adjusts heading size */
  }

  h3 {
    font-size: 1.1rem; /* Adjusts subheading size */
  }
}


/* Responsive styling */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  .image-grid {
    gap: 20px;
    grid-template-columns: repeat(4, 1fr);
  }

  .text-overlay {
    padding-top: 5px; /* Adjusts the padding from the top */
    padding-bottom: 45px; /* Reduces bottom padding to balance */
  }

  .name {
    font-size: 0.8rem;
    margin-top: -5px; /* Moves the text slightly up */
  }

  .number {
    font-size: 1rem;
  }

  h2 {
    font-size: 1.2rem;
  }

  h3 {
    font-size: 1rem;
  }
}

/* Styles for 480px */
@media (max-width: 480px) {
  .text-overlay {
    position: absolute;
    bottom: 10px; 
    padding: 5px;
    width: 100%;
    text-align: center;
    border-radius: 10px;
  }

  .text-overlay .name {
    font-size: 0.6rem;
    font-weight: bold;
    line-height: 2;
    margin: 10;
  }

  .text-overlay .number {
    font-size: 1.2rem;
    color: #a80000;
    font-weight: bold;
  }


  .image-container {
    position: relative;
    padding-block-start: 100%; 
  }


  .image-container img {
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
}
</style>

